/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SalaryRangeAnalysisEmployeeDetail = {
    employeeDataId: number;
    employeeId: string;
    employeeName: string;
    jobTitle: string;
    department: string | null;
    location: string | null;
    FTEStatus: string | null;
    rangeId: number;
    min: number | null;
    mid: number | null;
    max: number | null;
    baseSalary: number;
    status: SalaryRangeAnalysisEmployeeDetail.status;
    compaRatio: number | null;
    rangePenetration: number | null;
};

export namespace SalaryRangeAnalysisEmployeeDetail {

    export enum status {
        BELOW = 'below',
        WITHIN = 'within',
        ABOVE = 'above',
    }


}

